import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { ogTitle, ogImage, ogUrl, ogDescription, ogImageAlt } from './util';

export default class OpenGraph extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  render = () => {
    const { location } = this.props;
    return (
      <Helmet>
        <meta property="og:title" content={ogTitle(location)} />
        <meta property="og:type" content="business.business" />
        <meta property="og:image" content={ogImage(location)} />
        <meta property="og:url" content={ogUrl(location)} />
        <meta property="og:description" content={ogDescription(location)} />
        <meta property="og:site_name" content="Solv" />
        <meta property="business:contact_data:street_address" content={location.displayAddress} />
        <meta
          property="business:contact_data:locality"
          content={`${location.city}, ${location.state}`}
        />
        <meta property="business:contact_data:postal_code" content={location.zipCode} />
        <meta property="business:contact_data:country_name" content="United States" />
        <meta property="place:location:latitude" content={location.latLong.latitude} />
        <meta property="place:location:longitude" content={location.latLong.longitude} />
        <meta property="og:image:alt" content={ogImageAlt(location)} />
        <meta property="fb:app_id" content="514222109004412" />
      </Helmet>
    );
  };
}
